import { ProjectTypes } from '@platform/types';
import React from 'react';
import DatasetTypeIcon from '../DatasetTypeIcon';

export interface Props {
  workingLayer: ProjectTypes.AnyWorkingLayer;
}

const WorkingLayerIcon: React.FC<Props> = ({ workingLayer }) => {
  if (workingLayer.rendering.type === 'simple') {
    const simpleRenderingStyle = workingLayer.rendering.style as ProjectTypes.SimpleRenderingStyle;
    return (
      <DatasetTypeIcon
        type={workingLayer.type}
        iconColor={simpleRenderingStyle.baseColor}
        backgroundClasses="px-0 py-0"
      />
    );
  }

  if (workingLayer.rendering.type === 'shaded') {
    const shadedRenderingStyle = workingLayer.rendering.style as ProjectTypes.ShadedRenderingStyle;
    return (
      <div className="flex flex-shrink-0">
        <MapSvg colors={getColors(shadedRenderingStyle.cutPointSets[0])} />
      </div>
    );
  }

  return <>?</>;
};

export default WorkingLayerIcon;

function getArrayItems<T>(arr: T[]): [T, T, T] {
  const length = arr.length;
  const middleIndex = Math.floor(length / 2);
  return [arr[0], arr[middleIndex], arr[length - 1]];
}

const getColors = (rendering: ProjectTypes.CutPointSet) =>
  getArrayItems<string>(rendering.cutPoints.filter((x) => !!x.color).map((x) => x.color as string));

const MapSvg: React.FC<{ colors: string[] }> = ({ colors }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.66005 1.6665C3.45474 1.6665 1.66699 3.45426 1.66699 5.65956V14.3332C1.66699 16.5423 3.45785 18.3332 5.66699 18.3332H9.6531L5.66005 1.6665Z"
      fill={colors[0]}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.3337 1.6665C16.5428 1.6665 18.3337 3.45737 18.3337 5.6665V11.0415L9.41286 7.83139L7.91699 1.6665H14.3337Z"
      fill={colors[1]}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.3333 18.3332C16.5425 18.3332 18.3333 16.5423 18.3333 14.3332V12.9153L10 10.0415L11.4782 18.3332H14.3333Z"
      fill={colors[2]}
    />
  </svg>
);
